<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>

    <mat-dialog-actions>
      <button mat-dialog-close class="close-x-button">×</button>
    </mat-dialog-actions>
  </div>

  <mat-dialog-content>
    <h1 class="title">Docentes: formação e remuneração</h1>
    <div class="panel">
      <app-tabela
        ngSkipHydration
        class="table-component"
        [cabecalhoCustomizado]="true"
      >
        <ng-container cabecalho>
          <tr>
            <th class="table-header" colspan="2">Nível / Classe</th>
            <th class="table-header" rowspan="2">
              Nível de formação <sup>(1)</sup>
            </th>
            <th class="table-header" colspan="3">Jornada</th>
            <th class="table-header">Remuneração bruta mensal</th>
            <th class="table-header" rowspan="2">Mês/ano referência</th>
          </tr>
          <tr>
            <th class="table-header">Seq.</th>
            <th class="table-header">Denominação</th>
            <th class="table-header">Jornada total (em horas)</th>
            <th class="table-header">Sem interação (%)</th>
            <th class="table-header">Com interação (%)</th>
            <th class="table-header">PQR (R$)</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <ng-container *ngFor="let dados of dadosTabelaViewModel">
            <tr>
              <td class="table-cell align-center">
                <strong>{{ dados.seqDenominacao }}</strong>
              </td>
              <td class="table-cell">
                <input
                  [value]="dados.seqDenominacao"
                  class="display-input align-left"
                  disabled="true"
                  maxlength="2"
                />
              </td>
              <td class="table-cell" style="width: 18%">
                <select class="w-100 display-input align-left" disabled="true">
                  <option selected [value]="dados.idNivelFormacao">
                    {{ dados.descricaoNivelFormacao }}
                  </option>
                </select>
              </td>
              <td class="table-cell">
                <input
                  [value]="dados.totalJornadaTrabalho"
                  class="w-100 display-input align-center text-green"
                  disabled="true"
                  maxlength="2"
                />
              </td>
              <td class="table-cell">
                <input
                  [value]="dados.porcentSemInteracaoEducando"
                  class="w-100 display-input align-center text-green"
                  disabled="true"
                  maxlength="2"
                />
              </td>
              <td class="table-cell">
                <input
                  [value]="dados.porcentComInteracaoEducando"
                  class="w-100 display-input align-center text-green"
                  disabled="true"
                  maxlength="2"
                />
              </td>
              <td class="table-cell">
                <input
                  [value]="dados.remuneracaoBruta"
                  class="w-100 display-input align-center text-green"
                  disabled="true"
                  maxlength="2"
                />
              </td>
              <td class="table-cell">
                <input
                  [value]="dados.mesAnoRef"
                  class="w-100 display-input align-center"
                  disabled="true"
                  maxlength="2"
                />
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </app-tabela>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <button class="close-button" mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>
